// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"cd3a1314","667":"051d0cad"}[chunkId] + ".chunk.js";
};